import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, LocaleService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.getLocation = (locationNumber) => {
            return $scope.cpPolicyExtension.locations.find(location => location.number === locationNumber);
        };

        $scope.localeInfo = LocaleService.getLocaleInfo;

        $scope.estimateReceived =
            () => $scope.incident.estimateReceived.value && $scope.incident.estimateReceived.value.code === 'Yes';

        $scope.$watch('estimateReceived()', (newValue, oldValue) => {
            // switching from on to off
            if (!newValue && oldValue) {
                if (!$scope.incident.estRepairCost.aspects.valid) {
                    $scope.incident.estRepairCost.value = null;
                }
            }
        });

        $scope.incidentLocation =
            () => $scope.cpPolicyExtension.locations.find(location => location.number === $scope.incident.location.value);

        $scope.buildingsInLocation =
            () => $scope.cpPolicyExtension.propertyRiskUnits.filter(ru => ru.locationNumber === $scope.incident.location.value);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'LocaleService'];

export default fn;